import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {PartComponent} from '../components/PartComponent';
import {Block} from '../../models/Block';
import {AddPartWizard} from './AddPartWizard/AddPartWizard';
import {Part} from '../../models/Part';
import {RepetitionControls} from './RepetitionControls';
import {If} from '../../../../components/if';

interface OwnProps {
    number: number;
    block: Block;
    canEditOutline: boolean;
    onChange: (block: Block) => void;
    onPartAdd: (part: Part) => void;
    onPartTrashClick: (part: Part) => void;
    onTrashClick: () => void;
}

export const BlockComponent: FunctionComponent<OwnProps> = ({
    number,
    block,
    canEditOutline,
    onChange,
    onPartAdd,
    onTrashClick,
    onPartTrashClick,
}) => {
    const [addPartWizardVisible, setAddPartWizardVisible] = useState(false);

    return (
        <div className="block">
            <div className="block__title">
                Block {number}
                <If condition={!canEditOutline}>
                    <div className="block__repetitions">{block.repeats}x</div>
                </If>
                <If condition={canEditOutline}>
                    <button className="block__trash ion-md-trash" onClick={onTrashClick} />
                    <RepetitionControls block={block} onChange={onChange} />
                </If>
            </div>
            <div className="block__parts-container">
                <If condition={block.parts.length === 0}>
                    <div className="block__empty">
                        <div />
                        <div />
                    </div>
                </If>
                {block.parts.map((part) => {
                    return (
                        <PartComponent
                            key={part.__uuid}
                            part={part}
                            onMainDeviceChange={(mainDevice) => {
                                part.device_identifier = mainDevice;
                                onChange(block);
                            }}
                        >
                            <If condition={canEditOutline}>
                                <button className="part__trash ion-md-trash" onClick={() => onPartTrashClick(part)} />
                            </If>
                        </PartComponent>
                    );
                })}
                <If condition={canEditOutline}>
                    <div
                        className="btn btn-secondary ion-ios-add icon-left"
                        onClick={() => setAddPartWizardVisible(true)}
                    >
                        Add part
                    </div>
                </If>
                {addPartWizardVisible && (
                    <AddPartWizard
                        onAdd={(part) => {
                            setAddPartWizardVisible(false);
                            onPartAdd(part);
                        }}
                        onDismiss={() => setAddPartWizardVisible(false)}
                    />
                )}
            </div>
        </div>
    );
};
